import { computed, Ref } from 'vue';
import { useInjectThemeFonts } from './useInjectThemeFonts';

/**
 * Master composable that applies all theme entities
 *
 * This composable orchestrates the injection of all theme-related styles:
 * - Fonts (typography)
 * - Shadows (elevations) - when implemented
 * - Border radius - when implemented
 * - Spacing - when implemented
 * - etc.
 *
 * Usage in component:
 * ```ts
 * const { isApplied } = useApplyTheme();
 *
 * // Wait for theme to be applied before showing content
 * <template>
 *   <div v-if="isApplied">
 *     <h1 class="theme-font-h1">Styled with theme</h1>
 *   </div>
 * </template>
 * ```
 *
 * @returns {Object} - Object containing isApplied ref indicating if all theme entities are loaded
 */
export function useApplyTheme(): { isApplied: Ref<boolean> } {
  // Apply fonts
  const { isApplied: fontsApplied } = useInjectThemeFonts();

  // TODO: Add more theme entities here as they are implemented
  // const { isApplied: shadowsApplied } = useInjectThemeShadows();
  // const { isApplied: borderRadiusApplied } = useInjectThemeBorderRadius();

  // All theme entities must be applied for the overall state to be true
  const isApplied = computed(() => {
    return fontsApplied.value;
    // && shadowsApplied.value
    // && borderRadiusApplied.value;
  });

  return { isApplied };
}
